import gsap from "gsap";

export default class Suction {
  constructor(target) {
    this.target  = target
    this.el      = {}
    this.svg     = document.getElementById('js-menu-circle')
    this.init()
    this.gravity = Math.min(24, this.el.w / 2)

    this.mouse = {
      x: 0,
      y: 0,
      cx: 0,
      cy: 0,
    }

    this.flag = false

    this.el.target.addEventListener('mouseenter', this.mouseEnter.bind(this), false)
    this.el.target.addEventListener('mouseleave', this.mouseLeave.bind(this), false)
    this.mouseMove = this._mouseMove.bind(this)
    
    this.onRaf()
  }

  init() {
    //windowをリサイズさせた時に初期値の座標をリセットさせる
    const data = this.target.getBoundingClientRect()

    this.el.target = this.target
    this.el.x      = data.x
    this.el.y      = data.y
    this.el.w      = data.width
    this.el.h      = data.height
  }

  _mouseMove(e) {
    // this.mouse.x = e.clientX
    // this.mouse.y = e.clientY
    this.mouse.x = gsap.utils.mapRange(this.el.x,this.el.x + this.el.w, -this.gravity,this.gravity,e.clientX)
    this.mouse.y = gsap.utils.mapRange(this.el.y,this.el.y + this.el.h, -this.gravity,this.gravity,e.clientY)
  }

  mouseEnter() {
    this.flag = true
    // this.svg.classList.add('hover')
    
    addEventListener('mousemove', this.mouseMove)
  }
  
  mouseLeave() {
    this.flag = false
    this.mouse.cx = 0
    this.mouse.cy = 0
    
    gsap.to(this.el.target, {
      x: 0,
      y: 0,
      duration: 0.5,
      ease: 'elastic.out(1, 0.4)',
    })
    removeEventListener('mousemove', this.mouseMove)
  }

  onRaf() {
    if (this.flag) {
      this.mouse.cx = gsap.utils.interpolate(this.mouse.cx, this.mouse.x, 0.13)
      this.mouse.cy = gsap.utils.interpolate(this.mouse.cy, this.mouse.y, 0.13)
      gsap.set(this.el.target, {
        x: this.mouse.cx,
        y: this.mouse.cy
      })
    }

    requestAnimationFrame(this.onRaf.bind(this))
  }
}

const suctionElements = document.querySelectorAll('[data-suction]')
const suctionArray = []

;[].forEach.call(suctionElements, el => {
  const suctionInstance = new Suction(el)
  window.addEventListener('resize', (_) => {
    suctionInstance.init()
  })

  suctionArray.push(suctionInstance)
})

